import axiosPrivate from "@services/axiosPrivate";
import { GET_PRICES_URL } from "src/constants";

export const getPrices = (searchFilters) => {
    return axiosPrivate.get(GET_PRICES_URL, { params: searchFilters });
}